<div class="row" *ngIf="companyId">
    <div class="col d-flex mb-3">
        <app-company-audit-template-add [companyId]="companyId" (auditTemplateAdded)="companyUserAdded($event);"></app-company-audit-template-add>
    </div>
</div>
<section class="panel">
    <div class="panel-body">
        <div class="table-responsive" *ngIf="companyAuditTemplates?.length>0">
            <table class="table table-hover mb-none">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Audit Template</th>
                        <th>Category</th>
                        <th>Active</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let c of companyAuditTemplates;index as i">
                        <td>{{i+1}}</td>
                        <td>{{c.auditTemplateDescription}}</td>
                        <td>
                            {{c.auditCategoryDescription}}
                        </td>
                        <td>
                            <span class="fas fa-check" *ngIf="c.isActive"></span>
                            <span class="fas fa-times" *ngIf="!c.isActive"></span>
                        </td>
                        <td class="actions">
                            <a (click)="selectedAuditTemplate=c.auditTemplateId; confirmation.showMessage()" title="Delete Module" class="mb-1 mt-1 mr-2"><i class="fas fa-trash"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="card" *ngIf="companyAuditTemplates?.length==0">
            <div class="card-body card-info">
                <p>No Audit Templates</p>
            </div>
        </div>
    </div>
</section>

<app-confirmation-message #confirmation (confirmationClicked)="deleteAuditTemplate()"
                          [title]="'Confirmation'"
                          [message]="'Are you sure you want to remove this audit template?'">
</app-confirmation-message>
